<template>
  <div class="page">
    <div class="nav">
      <span
        :class="selected1 == '库存进销分析' ? 'selected1' : ''"
        @click="toggle1('库存进销分析')"
        >库存进销分析</span
      >
      <span>|</span>
      <span
        :class="selected1 == '库存进销汇总' ? 'selected1' : ''"
        @click="toggle1('库存进销汇总')"
        >库存进销汇总</span
      >
    </div>

    <div v-show="selected1 == '库存进销分析'">
      <year-filter-bar @change="onYearChange" ref="yearFilterBar" />

      <div class="canvas-box">
        <canvas id="myChart" class="myChart"></canvas>
      </div>

      <div class="list-box" v-if="result.monthitems">
        <div class="list-box-col">
          <p class="list-box-col__title">月份</p>
          <p
            class="list-box-col__content"
            v-for="item in result.monthitems"
            :key="item.text"
          >
            {{ item.text }}
          </p>
          <p class="list-box-col__content">本年累计</p>
        </div>
        <div class="list-box-col">
          <p class="list-box-col__title">入库金额</p>
          <p
            class="list-box-col__content"
            style="color: #2eadf5"
            v-for="item in result.monthitems"
            :key="item.text"
          >
            {{ item.amount1 }}
          </p>
          <p class="list-box-col__content" style="color: #2eadf5">
            {{ result.details[0].amount }}
          </p>
        </div>
        <div class="list-box-col">
          <p class="list-box-col__title">出库金额</p>
          <p
            class="list-box-col__content"
            style="color: #e44959"
            v-for="item in result.monthitems"
            :key="item.text"
          >
            {{ item.amount2 }}
          </p>
          <p class="list-box-col__content" style="color: #e44959">
            {{ result.details[1].amount }}
          </p>
        </div>
        <div class="list-box-col">
          <p class="list-box-col__title">结存金额</p>
          <p
            class="list-box-col__content"
            style="color: #16b603"
            v-for="item in result.monthitems"
            :key="item.text"
          >
            {{ item.amount3 }}
          </p>
          <p class="list-box-col__content" style="color: #16b603">
            {{ result.details[2].amount }}
          </p>
        </div>
      </div>
    </div>

    <div style="margin-bottom: 48px" v-show="selected1 == '库存进销汇总'">
      <search-bar
        @search="searchPurcsale"
        name=""
        placeholder="输入物料编号、名称、型号、仓库进行查找"
        ref="searchBar"
      />
      <year-month-filter-bar
        @change="searchPurcsale"
        ref="yearMonthFilterBar"
      />
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="(item, index) in list2"
          :key="index"
          :to="{ name: 'StockPurcsaleDetail', params: { item } }"
        >
          <div class="weui-cell__bd">
            <p>{{ item.pr_detail }}</p>
            <p class="list-item-muted">{{ item.pr_code }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.wh_description }}</p>
            <p class="list-item-muted">{{ item.pr_spec }}</p>
          </div>
        </router-link>
      </div>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{ list2.length }}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import YearMonthFilterBar from "@/components/YearMonthFilterBar.vue";
import YearFilterBar from "@/components/YearFilterBar.vue";
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    SearchBar,
    YearMonthFilterBar,
    YearFilterBar,
  },
  data() {
    let year = new Date().getFullYear();

    return {
      result: {},
      list2: [], // 库存进销汇总列表
      year,
      selected1: "库存进销分析",
      chart: null,
    };
  },
  mounted() {
    this.searchPurcSaleMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchPurcSaleMonth() {
      let me = this;

      me.$loading({
        url: "/api/storage/report/purcSaleMonth",
        params: {
          year: me.year,
        },
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.initChart(me.result.monthitems);
        }
      });
    },
    searchPurcsale() {
      let me = this;

      let yearMonthFilterBar = me.$refs.yearMonthFilterBar;
      let yearmonth = yearMonthFilterBar.yearmonth;

      let searchBar = me.$refs.searchBar;
      let keyword = searchBar.keyword;

      let params = {
        number: 1,
        size: 99999,
        mode: "DETAIL",
        condition: [
          { type: "number", field: "pd_ym", operation: "=", value: yearmonth },
        ],
        page: 1,
        start: 0,
        limit: 99999,
      };
      if (keyword) {
        params.condition.push({
          type: "condition",
          value: `(upper(pr_orispeccode) like '%${keyword}%' or upper(pr_code) like '%${keyword}%' or upper(pr_detail) like '%${keyword}%' or upper(wh_description) like '%${keyword}%')`,
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/storage/report/purcsale",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list2 = res.data.list.list;
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.result.monthitems);
      }
    },
    initChart(res) {
      var chart = this.chart,
        data = this.deal(res);
      // 初始化图表
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          // values: [-1, 0, 1, 2, 3, 4, 5],
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "入库金额") {
            return "#2eadf5";
          } else if (val === "出库金额") {
            return "#e44959";
          } else if (val === "结存金额") {
            return "#16b603";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05,
        });
      if (window.innerWidth < window.innerHeight) {
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }

      chart.interaction("pan");
      chart.legend({
        align: "center",
        itemWidth: null,
      });
      chart.render();
    },
    toggle1(val) {
      this.selected1 = val;

      if (val == "库存进销汇总") {
        this.searchPurcsale();
      }
    },
    onYearChange(year) {
      this.year = year;
      this.searchPurcSaleMonth();
    },
    deal(data) {
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "入库金额", value: 0 },
        { index: 12, type: "入库金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push(
          {
            index: i,
            text: item.text,
            type: "入库金额",
            value: item.amount1,
          },
          {
            index: i,
            text: item.text,
            type: "出库金额",
            value: item.amount2,
          },
          {
            index: i,
            text: item.text,
            type: "结存金额",
            value: item.amount3,
          }
        );
      });

      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push(
            {
              index: i,
              text: textArr[i],
              type: "入库金额",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "出库金额",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "结存金额",
              value: 0,
            }
          );
        }
      }

      return arr;
    },
  },
};
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}

.nav .selected1 {
  color: #38559f;
}

.canvas-box {
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.list-box-col {
  text-align: center;
}

.list-box-col p {
  line-height: 40px;
}

.list-box-col__title {
  font-weight: bold;
}

.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.filter-bar {
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
}

.filter-bar span {
  margin: 0 auto;
}

.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}
@media screen and (min-width: 500px) {
  .nav {
    display: none;
  }
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap{
    width: 100%;
  }
  .list-box-col p{
    line-height: 25px;
  }
}
</style>